module.exports = __webpack_public_path__ + "img/cart-icon.83d56799.svg";